<prlw-last-deals-table-header-ui
  [columnName]="columnName"
  [hasSorting]="hasSorting"
  [isDesSort]="isDesSort"
></prlw-last-deals-table-header-ui>
